import { useSiteContent } from "../../lib/content";
import { Container, Section } from "../ui/Container";
import { SectionHeading } from "../ui/SectionHeading";

export function HowItWorks() {
  const { content } = useSiteContent();
  const section = content.howItWorks;

  return (
    <Section id="como-funciona" labelledBy="como-funciona-title">
      <Container>
        <SectionHeading id="como-funciona-title" title={section.heading} subtitle={section.subtitle} />
        <ol className="grid gap-5 md:grid-cols-3">
          {section.items.map((step, index) => (
            <li key={`${step.n}-${index}`} className="rounded-xl border bg-surface p-5">
              <p className="font-heading text-sm text-accent-terminal">{step.n}</p>
              <h3 className="mt-2 font-heading text-xl font-semibold text-primary">{step.title}</h3>
              <p className="mt-2 text-sm text-muted">{step.text}</p>
            </li>
          ))}
        </ol>
      </Container>
    </Section>
  );
}
